class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;

    // Only one mega/dropdown open at a time (owner, 2026-07-27): sections/header.liquid's
    // initPfannerMegaHover() opens the entering nav item's <details> the instant the pointer
    // (or keyboard focus) lands on it, but only closes the item being left after a 150ms
    // scheduleClose() grace timer — that gap exists so the panel doesn't flicker shut while
    // the pointer crosses the little strip between the nav bar and the floating panel below
    // it. Moving straight from one nav item to the next opens the new item well inside that
    // 150ms window, so both stayed open/visible simultaneously until the old one's timer
    // finally caught up (confirmed by dispatching the real mouseenter/mouseleave sequence and
    // reading `details.open` a tick apart: both true from t=0 through t=60ms, only resolving
    // at t=150ms).
    //
    // Every way a `<details class="mega-menu">` opens here — hover, keyboard focus, or a
    // click that bypasses the grace timer entirely — ends up setting its `open` IDL attribute,
    // which (whatever triggered it) fires this native `toggle` handler. `open`/`close()` on the
    // attribute happen synchronously; only the `toggle` *event* dispatch is queued as a task,
    // so this still runs within about one tick — far short of the 150ms window. On open, force
    // every *other* header-menu's details closed immediately instead of waiting on their own
    // grace timers, since hover/focus has already moved to this one. Verified this leaves at
    // most one `details[open]` at any point, including the direct-pointer-move case above.
    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    }

    // Recompute from live DOM state rather than trusting `this.mainDetailsToggle.open` alone:
    // the forced closes above mutate their `open` attribute synchronously, but the *other*
    // menu's own `toggle` event (and onToggle call) is still queued and can resolve after this
    // one — reading "is anything currently open" keeps preventHide correct no matter which
    // onToggle call happens to run last.
    this.header.preventHide = !!document.querySelector('.header__inline-menu header-menu details[open]');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
